//@flow

import {multichatRealTimeAuthenticationTokenEndpoint} from '../api';
import type {RealTimeAuthenticationTokenResponse} from '../api';

export function getMultichatRealTimeAuthenticationTokenService(): Promise<RealTimeAuthenticationTokenResponse> {
  return multichatRealTimeAuthenticationTokenEndpoint().toPromise();
}
